import { useQuery } from '@tanstack/react-query';
import { freshnessApi } from '../../services/freshnessApi';

/** How old each data source is — public, the backend caches it for 5 minutes. */
export function useFreshness() {
  return useQuery({ queryKey: ['freshness'], queryFn: freshnessApi.get, staleTime: 5 * 60_000, retry: 1 });
}
